exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "*[data-v-9c8a4f38]{box-sizing:border-box;margin:0;padding:0}.img[data-v-9c8a4f38]{height:26.04167vw;width:100%}", "", {"version":3,"sources":["/root/workspace/xyw-website_9ut8/src/views/Fashion.vue"],"names":[],"mappings":"AAiBA,mBACE,sBACA,SACA,SAAA,CAEF,sBACE,kBACA,UAAA,CAAA","file":"Fashion.vue?vue&type=style&index=0&id=9c8a4f38&lang=scss&scoped=true&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n*{\n  box-sizing: border-box;\n  margin:0;\n  padding:0;\n}\n.img{\n  height:500px;\n  width:100%;\n}\n"],"sourceRoot":""}]);

// exports
